import { SelectContentProps } from 'components/ui/Forms';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useOrderType() {
  const { token } = useAuth();
  const getOrderTypes = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(`/order-types?asList=1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((orderType: any) => ({
      value: orderType.id,
      name: orderType.name,
    }));
  };

  return { getOrderTypes };
}
